import Preloader from "./Componets/partials/PreviewLoad.js";
import MainComponent from "./MainComponent.js";


function App() {
  return (
    <div>
     <Preloader />
     <MainComponent/>
    </div>
  );
}

export default App;
